import { ENV } from "../utils";

export class User {
    baseApi = ENV.BASE_API;

    async getMe(accessToken) {
        try {
            const url = `${this.baseApi}/${ENV.API_ROUTES.USER_ME}`;
            const params = {
                headers: {
                    Authorization: `${accessToken}`
                }
            }
            const response = await fetch(url, params);
            const result = await response.json();
            console.log(result);
            if (response.status !== 200) throw result;

            return result;
        } catch (error) {
            throw error;
        }
    }

    async createUser(accessToken, data) {
        try {
            const formData = new FormData();
            Object.keys(data).forEach((key) => {
                if (key === 'fileAvatar') {
                    formData.append('avatar', data[key]);
                } else {
                    formData.append(key, data[key]);
                }
            });

            const url = `${this.baseApi}/${ENV.API_ROUTES.USER}`;
            const params = {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: formData,
            };

            const response = await fetch(url, params);
            const result = await response.json();
            if (response.status !== 201) throw result;
            return result;
        } catch (error) {
            throw error;
        }
    }


    async getUsers(accessToken, active = undefined) {
        try {
            const url = `${this.baseApi}/${ENV.API_ROUTES.USERS}?active=${active}`;
            const params = {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }
            const response = await fetch(url, params);
            const result = await response.json();
            if (response.status !== 200) throw result;
            return result;
        } catch (error) {
            throw error;
        }
    }

    async updateUser(accessToken, idUser, userData) {
        try {
            const data = userData;
            if (!data.password) {
                delete data.password;
            }
            console.log('USerData: ', userData.password);
            console.log(userData);
            const formData = new FormData();
            Object.keys(data).forEach((key) => {
                if (key === 'fileAvatar') {
                    formData.append('avatar', data[key]);
                } else {
                    formData.append(key, data[key]);
                }
            });

            const url = `${ENV.BASE_API}/${ENV.API_ROUTES.USER}/${idUser}`;
            const params = {
                method: "PATCH",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                body: formData,
            };

            const response = await fetch(url, params);
            const result = await response.json();
            if (response.status !== 200) throw result;

            return result;
        } catch (error) {
            throw error;
        }
    }

    async updateUserActive(accessToken, idUser, userData) {
        try {
            const data = userData;
            if (!data.password) delete data.password
            const formData = new FormData();
            console.log('Correo userdata: ', userData.email);
            Object.keys(data).forEach((key) => {
                formData.append(key, data[key]);
            });
            if (data.fileAvatar) {
                formData.append("avatar", data.fileAvatar);
            }
            const url = `${ENV.BASE_API}/${ENV.API_ROUTES.USERR}/${idUser}`
            const params = {
                method: "PATCH",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                body: formData,
            };
            const response = await fetch(url, params);
            const result = await response.json();
            if (response.status !== 200) throw result;
            return result;
        } catch (error) {
            throw error;
        }
    }

    async deleteUser(accessToken, idUser) {
        try {
            const url = `${this.baseApi}/${ENV.API_ROUTES.USER}/${idUser}`;
            const params = {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
            };
            const response = await fetch(url, params);
            const result = await response.json();
            if (response.status !== 200) throw result;
            return result;
        } catch (error) {
            throw error;
        }
    }

    //Traer por Rol de sistemas
    async getUserSistemas(accessToken, role = 'sistemas') {
        try {
            const url = `${this.baseApi}/${ENV.API_ROUTES.SISTEMAS}/role?role=${role}`;
            const params = {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }
            const response = await fetch(url, params);
            const result = await response.json();
            const sistemas = result.map(user => ({
                key: user.email,
                text: `${user.firstname} ${user.lastname}`,
                value: user.email
            }))
            if (response.status !== 200) throw result;
            return sistemas;
        } catch (error) {
            throw error;
        }
    }
}